var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"position-fixed translate-middle-x start-50 top-0 w-100 zi-99"},[_c('div',{staticClass:"alert",class:`alert-`+ _vm.type,attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }